export const GIFT = 'GIFT';
export const WALLET = 'WALLET';
export const WALLET_XXLBONUS = 'WALLET_XXLBONUS';
export const TIP_CHATROOM = 'TIP_CHATROOM';
export const BOBSTORE_PURCHASE = 'BOBSTORE_PURCHASE';



// WEBPACK FOOTER //
// ./src/constants/wallet.js